import React from 'react'
import EkycDocument from 'e-submission/components/Card/EkycDocument'

const withHoc = (hoc) => {
  const WrappedComponent = (props) => {
    return <EkycDocument {...props} />
  }

  return hoc(WrappedComponent)
}

export default withHoc
